import { Avatar, SxProps, Theme } from '@mui/material';
import React from 'react';
import { AuthUser, UsersDTO } from '../../../redux/identity/identityTypes';

export interface UserAvatarProps {
 user?: UsersDTO | null;
 size?: number;
 sx?: SxProps<Theme>;
}

export const getUserInitials = (user: UsersDTO | null | undefined): string => {
 if (!user) return '?';
 if ('Name' in user && user.Name) {
  return user.Surname
   ? `${user.Name.charAt(0)}${user.Surname.charAt(0)}`
   : user.Name.charAt(0);
 }
 return '?';
};

const getAvatarSrc = (user: AuthUser | UsersDTO | null | undefined): string => {
 if (user && 'ProfileImageBase64' in user && user.ProfileImageBase64) {
  return `data:image/png;base64,${user.ProfileImageBase64}`;
 }
 return '';
};

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 64, sx }) => {
 const initials = getUserInitials(user);
 const fullName =
  user?.Name || user?.Surname ? `${user?.Name} ${user?.Surname}` : '';
 const avatarSrc = getAvatarSrc(user);

 return (
  <Avatar
   sx={{
    width: size,
    height: size,
    bgcolor: (th) => th.palette.kemek.lightestGray,
    color: (th) => th.palette.kemek.darkGray,
    fontSize: size > 40 ? '20px' : '14px',
    fontWeight: 500,
    ...sx,
   }}
  >
   {/* {avatarSrc ? ( */}
   {/* <img
     src={avatarSrc}
     alt={fullName}
     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
   ) : ( */}
   {initials}
   {/* )} */}
  </Avatar>
 );
};

export default UserAvatar;
